
import React, { MouseEvent, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import {useWindowSize} from 'react-use';

import { currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSearchBoxShowAtom, isSaveLoadingAtom } from 'library/store';

import useUtils from 'library/utils';

import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { makeStyles } from '@mui/material';

import { useTheme } from '@mui/material/styles';


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!

import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';



import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import useSchoolYearService, { useBasicFilterSchoolYear, useBasicFilterSchoolYearClass } from 'features/setup/services/SchoolYear';
import { ISchoolYearClass, defaultSchoolYearClassTemplate,  ISchoolYearPeriod, ISchoolYearPeriodExam, defaultSchoolYearClass, ISchoolYearClassSubject, ISchoolYearClassSubjectSchedule, defaultSchoolYearClassSubject } from 'features/setup/models/SchoolYear';

import { ISchoolYear} from 'features/setup/models/SchoolYear';

import useEntityService, { useBasicFilterEntity } from 'features/services/Entity';

import { BasicTextFilterForm, defaultBasicTextFilterProps } from 'components/ui/BasicTextFilterForm';

import { MdOutlineAdd } from 'react-icons/md';

// import WidgetSummary from './widgets/WidgetSummary';
// import WidgetBarChart from './widgets/WidgetBarChart';
// import WidgetPieChart from './widgets/WidgetPieChart';
import { Button } from '@mui/material';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';
import { DateSelectArg,
  EventApi,
  EventClickArg,
  EventChangeArg,EventInput } from '@fullcalendar/core';
import { isFalsy } from 'utility-types';
import {parse, format} from 'date-fns';
import { Enum_DAY_WEEK, IEnumerationItem } from 'features/configuration/models/Enumeration';




export const TimeTableForm = () => {

  const theme = useTheme();

  const { t, i18n } = useTranslation();

  const {generateDistinctColorFromName, toDateWithoutSeconds} = useUtils();

  const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);

  const {language: lg, schoolYears, applicationSetup, roleEntities} = useRecoilValue(currentUserSessionAtom);
  

  const {height, width} = useWindowSize();

  const { getSchoolYearClassTimeTable, getSchoolYearTimeSlots} = useSchoolYearService();

  const {retrieveEntity, retrieveData, openEntityActionDrawer, openEntityPrintDrawer, openEntityPrintDrawerEx,
        checkEntityExpressionSyntax, checkEntitySaveAuthorization, hasEntityAuthorization } = useEntityService();

  
  const [schoolYearId, setSchoolYearId] = useState(-1);
  const [schoolYearClassId, setSchoolYearClassId] = useState(-1);
  const [schoolYearClassName, setSchoolYearClassName] = useState('');
  const [timetableEvents, setTimetableEvents] = useState<EventInput[]>([]);
  const [colors, setColors] = useState<Record<string, string>>({});

  const [weekStart, setWeekStart] = useState<Date>(new Date());
  const [weekEnd, setWeekEnd] = useState<Date>(new Date());

  const [minTimeStr, setMinTimeStr] = useState<string>("07:00");
  const [maxTimeStr, setMaxTimeStr] = useState<string>("17:00");

  const [isSearchBoxShow, setIsSearchBoxShow] = useRecoilState(isSearchBoxShowAtom);
  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);
  const basicFilterSchoolYearClass = useBasicFilterSchoolYearClass( 
    async (event: React.MouseEvent<unknown>, row: ISchoolYearClass) => {
        setIsSearchBoxShow(false);

        const {id, name, schoolYearId} = row;

        await loadSchoolYearClassTimetable(id, name, schoolYearId);        
      }
  );

  const loadSchoolYearClassTimetable = async (schoolYearClassId: number, schoolYearClassName: string, schoolYearId: number) => {
    
        setSchoolYearClassId(schoolYearClassId);  
        setSchoolYearClassName(schoolYearClassName);    
        setSchoolYearId(schoolYearId); 

        const arrTimeSlots = await getSchoolYearTimeSlots(schoolYearId);
        const sortedTimeSlots = arrTimeSlots.map(slot => ({
            startTime: toDateWithoutSeconds(slot.startTime),
            endTime: toDateWithoutSeconds(slot.endTime)
            })).sort((a, b) => a.startTime.getTime() - b.startTime.getTime());
        
        const timeTable = await getSchoolYearClassTimeTable(schoolYearClassId);

        setMinTimeStr("07:00");
        setMaxTimeStr("17:00");

        const {timetableEvents, weekStart, weekEnd} = timeTable;
        const colorSet = new Set( timetableEvents.map( ({title, }) => title ));
        const colorMap : Record<string, string> = {};

        for (let i = 0; i < timetableEvents.length; i++) {
          const {title} = timetableEvents[i];
          if(isFalsy(title)) continue;

          if( isFalsy(colorMap[title]))
            colorMap[title] = generateDistinctColorFromName(title);

          // const color = generateRandomColor();
          // colorMap[`item${i + 1}`] = color;
          timetableEvents[i].backgroundColor = colorMap[title];
          timetableEvents[i].textColor = 'black';          
        }
  
        setTimetableEvents(timetableEvents);
        setWeekStart(weekStart);
        setWeekEnd(weekEnd);
        
        if(sortedTimeSlots.length > 0) {
          setMinTimeStr( format(sortedTimeSlots.at(0)!.startTime, 'HH:mm') );
          setMaxTimeStr( format(sortedTimeSlots.at(-1)!.endTime, 'HH:mm'));
        }
  }

  

  useEffect( () => {        
    setCurrentFormName(t('Time table'));
    setCurrentBasicTextFilterProps(basicFilterSchoolYearClass);
    
  }, []);    

  useEffect(() => {
    async function _() {
             
      //const dash = await getSchoolYearDashboard(applicationSetup.currentSchoolYearId);
      //const schoolYear = schoolYears.find(s => s.id === applicationSetup.currentSchoolYearId);
      //setSchoolYearName(schoolYear?.name || '');
      
      //setDashboard(dash);     
    }
    _();
  }, []);
  
  // Custom title component for the header
  const HeaderTitle = () => {
    return <Typography variant="h6">School Timetable</Typography>;
  };

  const renderHeader = (info: any) => {
    return (
      <div>
        {info.date.toLocaleDateString(lg, { weekday: 'long' })}
      </div>
    );
  };


  const handleEventClick = (clickInfo: EventClickArg) => {

    if(!hasEntityAuthorization('SchoolYearClassSubjectSchedule')) return;

    const schoolYearClassSubjectId = clickInfo.event._def.extendedProps['Id'] as unknown as number;
    
    openEntityActionDrawer('SchoolYearClassSubjectSchedule', schoolYearClassSubjectId);
        
    // const newTitle = prompt('Enter subject:', clickInfo.event.title);
    // if (newTitle !== null) {
    //   clickInfo.event.setProp('title', newTitle);
    // }
  };

  const handleDateClick = (arg: DateClickArg) => {

    // TODO : Direct add here, day and slot is already known...
    //console.log(arg);
    //alert(arg.dateStr);
  };

  const handleEventChange = (changeInfo: EventChangeArg) => {
    const updatedEvents = timetableEvents.map((event) =>
      event.id === changeInfo.event.id
        ? {
            ...event,
            start: changeInfo.event.start!,
            end: changeInfo.event.end!,
            title: changeInfo.event.title
          }
        : event
    );
    setTimetableEvents(updatedEvents);
  };

  const [openSchoolYearClassSubjectSchedule, setOpenSchoolYearClassSubjectSchedule] = useState<boolean>(false);
  const handleClickAddSchoolYearClassSubjectSchedule = (event: any) => {
      setOpenSchoolYearClassSubjectSchedule(true);
    }

    const handleOkSchoolYearClassSubjectSchedule = (event: React.MouseEvent<unknown>) => {
        
      setOpenSchoolYearClassSubjectSchedule(false);
    }

    const actionData = async (event: MouseEvent<HTMLButtonElement>) => {
          openEntityActionDrawer('ClassTimetable', schoolYearClassId);
        }

    const printData = async (event: MouseEvent<HTMLButtonElement>) => {
          openEntityPrintDrawerEx('ClassTimetable', 0 , 
              [ {name: 'SchoolYearClassId', value: schoolYearClassId, dateValue: new Date()},
                {name: 'SchoolYearId', value: schoolYearId, dateValue: new Date()}
              ]);
        }

    const afterAction = async (event: MouseEvent<HTMLButtonElement>) => {    
          await loadSchoolYearClassTimetable(schoolYearClassId, schoolYearClassName, schoolYearId);      
        //    queryClient.invalidateQueries(['RequestType',currentEntityIdForAction]);        
        //    await retreiveData(currentEntityNameForAction,currentEntityIdForAction, refetch);        
        //    reset(_data);        
        }

  return (
    <Box sx={{ mx: 0.1 }}>
      <Grid container rowSpacing={1} columnSpacing={3}>
        <Grid item xs={12}>
          <Stack flexDirection='column'>
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <Button id='btnAction' onClick={actionData} sx={ {display:'none'}}  />  
              <Button id='btnPrint' onClick={printData} sx={ {display:'none'}}  />  
              <Button id='btnAfterAction' onClick={afterAction} sx={ {display:'none'}}  />

              <Typography variant="h6" id="tableTitle" color="primary" noWrap sx={{...typographyGroupBoxStyling}}>
                {` ${t('Time table')} ->  ${t(('Class'))} : ${schoolYearClassName}`}
              </Typography>
              
            </Box>
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <div style={{ width: '100%' }}>
                <FullCalendar
                  plugins={[timeGridPlugin, interactionPlugin]}
                  locale={lg}
                  initialView="timeGridWeek"
                  headerToolbar={false}
                  initialDate={weekStart}
                  validRange={{
                    start: weekStart,
                    end: weekEnd//new Date(new Date(weekStart).setDate(new Date(weekStart).getDate() + 5))
                  }}
                  slotMinTime={minTimeStr}
                  slotMaxTime={maxTimeStr}
                  // slotDuration="00:10:00"
                  allDaySlot={false}
                  nowIndicator={true}

                  slotLabelFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    //meridiem: false,
                  }}



                  editable={true}
                  events={timetableEvents}
                  dayHeaderContent={renderHeader}

                  eventClick={handleEventClick}
                  eventChange={handleEventChange}
                  dateClick={handleDateClick}
                  height="auto"
                />
                {/* <FullCalendar
                  plugins={[timeGridPlugin]} // {[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  locale={lg}
                  initialView="timeGridWeek"
                  // headerToolbar={{
                  //   //left: 'prev,next today',
                  //   //center: 'title',
                  //   left: '',
                  //   center: '',
                  //   //right: 'dayGridMonth,timeGridWeek,timeGridDay'
                  //   right: ''
                  // }}
                  headerToolbar={false}
                  //height="700px"
                  initialDate={weekStart} // Set the initial start date of the week view
                  //weekends={false} // Optional: Hide weekends if desired
                  validRange={{ start: weekStart, end: weekEnd }} // Set the valid date range for the week view
                  nowIndicator={true} // Show current time indicator
                  height="auto" // Auto-adjust height to content
                  allDaySlot={false} // Hide all-day slot
                  slotMinTime="07:00:00" // Start time for the timetable (e.g., 08:00 AM)
                  slotMaxTime="17:00:00" // End time for the timetable (e.g., 06:00 PM)
                  slotLabelFormat={{
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    //meridiem: false,
                  }}
                  // Custom toolbar rendering function
                  
                  
                  events={timetableEvents}

                  dayHeaderContent={renderHeader}
                />  */}
              </div>
            </Box>
            { openSchoolYearClassSubjectSchedule && <FormDialog open={openSchoolYearClassSubjectSchedule} maxWidth='sm'
                okText={t('OK')} cancelText='' title={`${t('Subject')} ... ${t('Time slot')}`} onCancel={()=> {}} 
                onClose={()=> {setOpenSchoolYearClassSubjectSchedule(false);}} onOk={handleOkSchoolYearClassSubjectSchedule}  >
                  <Stack flexDirection='column'>
                    <Box sx={{ mt: 1, width: '100%' }} ></Box>
                    <Box sx={{ mt: 1, width: '100%' }} ></Box>
                  </Stack>
            </FormDialog> }
          </Stack>
        </Grid>
      </Grid>
      
    </Box>
  )
}
